import { SvgIcon, SvgIconProps } from "@mui/material";

export const BillingInvoiceFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M23.341 24.5V5.247c0-.44-.248-.844-.643-1.042l-1.155-.58a1.167 1.167 0 0 0-1.04-.004l-1.835.907-1.798-.903a1.167 1.167 0 0 0-1.044-.002l-1.818.905-1.819-.905a1.167 1.167 0 0 0-1.043.002l-1.798.903-1.835-.907a1.167 1.167 0 0 0-1.04.003l-1.156.58a1.167 1.167 0 0 0-.642 1.043V24.5"
        clipRule="evenodd"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M23.341 24.5V5.247c0-.44-.248-.844-.643-1.042l-1.155-.58a1.167 1.167 0 0 0-1.04-.004l-1.835.907-1.798-.903a1.167 1.167 0 0 0-1.044-.002l-1.818.905-1.819-.905a1.167 1.167 0 0 0-1.043.002l-1.798.903-1.835-.907a1.167 1.167 0 0 0-1.04.003l-1.156.58a1.167 1.167 0 0 0-.642 1.043V24.5"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="m11.675 12.254 1.75 1.75 2.916-2.917M16.909 17.496h-5.834M25.659 24.496H2.325"
      />
    </svg>
  </SvgIcon>
);
